import React from 'react';
import { Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-white pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src="https://assets.auxodev.dk/assets/8283c528-e59c-4f9d-b50b-8d919a0a0240/b674d1e6-956f-4f26-bd31-317c5bb756df.jpg" 
              alt="Materialepladsen" 
              className="h-24 w-auto object-contain rounded-lg"
            />
            <p className="text-white leading-relaxed text-sm">
              Din lokale leverandør af kvalitetsmaterialer til have og anlæg på Djursland. 
              Vi har pladser i både Grenå og Glesborg.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/paapladsen" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-zinc-800 rounded-full flex items-center justify-center hover:bg-black transition-colors" aria-label="Følg os på Facebook">
                <Facebook size={16} />
              </a>
            </div>
          </div>

          {/* Grenå */}
          <div>
            <h4 className="text-base font-bold mb-4 flex items-center gap-2">
              <MapPin size={16} className="text-white" />
              Grenå Afdeling
            </h4>
            <ul className="space-y-2 text-white text-sm">
              <li>Bredstrupvej 42</li>
              <li>8500 Grenaa</li>
              <li>
                <a href="tel:+4520181271" className="hover:text-white/80 transition-colors flex items-center gap-2">
                  <Phone size={14} />
                  +45 20 18 12 71
                </a>
              </li>
            </ul>
          </div>

          {/* Glesborg */}
          <div>
            <h4 className="text-base font-bold mb-4 flex items-center gap-2">
              <MapPin size={16} className="text-white" />
              Glesborg Afdeling
            </h4>
            <ul className="space-y-2 text-white text-sm">
              <li>Håndværkervej 7, A-C</li>
              <li>8585 Glesborg</li>
              <li>
                <a href="tel:+4520181271" className="hover:text-white/80 transition-colors flex items-center gap-2">
                  <Phone size={14} />
                  +45 20 18 12 71
                </a>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-base font-bold mb-4">Information</h4>
            <ul className="space-y-2 text-white text-sm">
              <li>CVR: 42131059</li>
              <li>Åbningstider: Se under lokationer</li>
              <li>
                <a href="mailto:Suneroedkjer@gmail.com" className="hover:text-white/80 transition-colors flex items-center gap-2">
                  <Mail size={14} />
                  Suneroedkjer@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-800 text-center text-white text-xs">
          <p>&copy; {new Date().getFullYear()} Materialepladsen. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
